<!-- <div style="position: relative;">
  <img src="../../../assets/App24PA assets/IlSole24ORE-logo.png" style="position: absolute;top:0px;right:60px;"/>
</div> -->
<!-- <mat-progress-bar *ngIf="spinner" mode="indeterminate"></mat-progress-bar> -->
<div fxLayout="column" >
  <!-- <owl-date-time-inline [stepHour]="1" [stepMinute]="5"></owl-date-time-inline> -->
  <form novalidate class="mat-distance" (submit)="login()" #f="ngForm" fxLayout="row" fxLayoutAlign="center" fxFlexOffset="105px">
    <mat-card fxLayout="column" fxFlex.gt-sm="400px" fxFlex.lt-sm="300px" style="
      background: #ffffff; border: 1px solid rgb(191, 191, 191); box-shadow: rgba(119, 178, 31, 0) 0px 1px 6px 1px; padding: 30px; border-radius: 15px;">
      <mat-card-header style="align-items: center;justify-content: center;padding-right: inherit;">
          <img style="width:100px; height: 100px;" src="../../../assets/img/Clamor.jpg" alt="">
          <!-- <img fxFlex="50px" src="../../../assets/icons/logohd.svg" alt=""> CUSTOMIZATION-SOLE24ORE -->
      </mat-card-header>
        <div fxLayout="column">
         <!--  <mat-card-title fxFlexOffset="3px">App24</mat-card-title> -->
          <!-- <mat-card-title fxFlexOffset="3px">Il Sole 24 ORE</mat-card-title> CUSTOMIZATION-SOLE24ORE -->
          <!-- <mat-card-subtitle>{{'Multilang.loginSubtitle' | translate}} <br> -->
          <mat-card-subtitle class="py-1" style="text-align: center;">(Versione {{version}})</mat-card-subtitle>
        </div>
      <mat-card-content fxLayout="column" class="login-card-content">
        <!-- Email -->
        <div class="textbox" id="textbox-mail">
          <i class="fa fa-user" aria-hidden="true"></i>
          <input spellcheck="false" type="text" matInput required placeholder="{{'Multilang.userName' | translate}}" [(ngModel)]="user" name="user">
        </div>
        <!-- Password -->
        <div class="textbox">
          <i class="fa fa-lock" aria-hidden="true"></i>
          <input spellcheck="false" type="password" matInput required placeholder="Password" [type]="visible ? 'text' : 'password'" [(ngModel)]="password"
          name="password" >

            <div *ngIf="visible" class="visible-icon"><i class="fa fa-eye" aria-hidden="true" style="cursor: pointer" (click)="visible = !visible"></i></div>
            <div *ngIf="!visible" class="visible-icon"><i class="fa fa-eye-slash" aria-hidden="true" style="cursor: pointer" (click)="visible = !visible"></i></div>
        </div>
      </mat-card-content>
      <mat-card-actions class="mt-3">
        <div class="container-fluid">
          <div class="row justify-content-between">
            <div class="col-12 pl-0">
              <a class="pl-2" href="mailto:info@app24pa.it" id="contactsLink">Hai problemi? contattaci</a>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-7 pl-0">
              <a class="pl-2" routerLink="/reset-password" id="resetPasswordLink">{{'Multilang.resetPasswordButton' | translate}}</a>
            </div>
            <div class="col-3 px-0">
              <!-- il bottone -->
              <div class="spinner-container pl-2">
                <!-- Spinner -->
                <mat-spinner *ngIf="spinner" [diameter]="20"></mat-spinner>
              </div>
              <button type="submit" [disabled]="f.invalid" [ngClass]="{
                'login-button': true,
                'login-button-active': !f.invalid,
                'login-button-disabled': f.invalid
              }"> LOGIN</button>
            </div>
          </div>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
<!-- Loading -->
<div class="loading-2" *ngIf="spinner">
</div>
